import { Http } from './baseAPIClient'

export class ApiHttp extends Http {}

export const client = new ApiHttp()
